import React, { Component } from 'react';

// CSS
import './styles.css';

export default class NfTableHeader extends Component {
  _renderAlignmentClass = (alignment) => {
    switch (alignment) {
      case 'left': {
        return 'NfTableHeader__cell--left';
      }

      case 'right': {
        return 'NfTableHeader__cell--right';
      }

      case 'center': {
        return 'NfTableHeader__cell--center';
      }

      default: {
        return '';
      }
    }
  }

  render() {
    const { headers } = this.props;

    return (
      <thead className="NfTableHeader">
        <tr>
          <td></td>
          {
            headers.map((header, index) => (
              <td
                className={`
                  NfTableHeader__cell 
                  ${this._renderAlignmentClass(header.alignment)}
                `}
                key={index}
              >
                {header.title}
              </td>
            ))
          }
        </tr>
      </thead>
    );
  }
}
